<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-05 10:34:19
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-05 13:48:38
 * @FilePath: /chaoyongtuan/src/views/shopManage/addMaterial/components/panelHeader.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="flex-row-align-center">
			<div class="yx-color-text-primary font-h4-medium title-content fz-16">
				<slot name="title"></slot>
			</div>
			<div class="yx-color-text-secondary font-h6-regular ml-8">
				<slot name="subTitle"></slot>
			</div>
		</div>
		<div v-if="btnText" class="mt-12 flex-row-align-center">
			<el-button type="primary" @click="$emit('btnClick')">
				{{ btnText }}
			</el-button>
			<div class="yx-color-text-secondary font-h6-regular ml-12">
				<span>已添加</span>
				<span class="yx-color-text-primary font-h6-medium ml-2 mr-2">
					<slot name="count"></slot>
				</span>
				<span>条</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		btnText: {
			type: String,
			default: null,
		},
	},
};
</script>

<style lang="less" scoped>
.title-content{
	position: relative;
	font-weight: 500;
	padding-left: 8px;
	&::after{
		content: '';
		position: absolute;
		width: 3px;
		height: 17px;
		background-color: #1890FF;
		left: 0px;
		top: 3px;
	}
}
</style>
